var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Messages } from 'primereact/messages';
import { DropdownOption } from '../../../classes/definitions/formItem/ElementConfig';
import * as productFactory from '../../../classes/definitions/product/product';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import productSchema from '../../../schemas/productSchema';
import ProductService from '../../../services/products.service';
import Email from '../../UI/Builder/Builder'; // Adjust the import path for Email component
import Input from '../../UI/Input/Input';
import * as _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
var ProductForm = /** @class */ (function (_super) {
    __extends(ProductForm, _super);
    function ProductForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.bottomMessages = null;
        _this.productService = new ProductService(_this.api);
        _this.state = {
            formConfig: _.cloneDeep(productSchema),
            formIsValid: false,
            discardPopupVisble: false,
            brandsSuggestions: [],
            categoriesSuggestions: [],
            loadedCategories: [],
            showModal: false,
            currentId: '',
            currentModalContent: {
                designHtml: '',
                designJson: null,
            },
        };
        // Method to set up field options after fetching async data
        _this.setupFieldsOptions = function (data) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            if (_this.editId !== '-1') {
                _this.props.isEdit(true);
                _this.setStatuses(updatedFormConfig, _.get(data, 'statuses.statuses'));
            }
            _this.setupOptionTypes(updatedFormConfig, _.get(data, 'optionTypes.data'));
            _this.setupProductLabels(updatedFormConfig, _.get(data, 'productLabels'));
            _this.setState({ formConfig: updatedFormConfig }, function () {
                // After setting up the async options
                if (_this.editId !== '-1') {
                    _this.getProduct(_this.editId);
                }
                else {
                    // Deleting the status on the page for creating a product
                    _this.deleteStatusField();
                }
            });
        };
        // Method to set statuses in form config
        _this.setStatuses = function (updatedFormConfig, rawStatuses) {
            for (var key in rawStatuses) {
                if (Object.prototype.hasOwnProperty.call(rawStatuses, key)) {
                    updatedFormConfig.status.elementConfig.options.push(new DropdownOption({
                        label: NotosService.formatStatuses(key),
                        value: key,
                    }));
                }
            }
        };
        // Method to set up option types in form config
        _this.setupOptionTypes = function (updatedFormConfig, rawOptionTypes) {
            for (var _i = 0, rawOptionTypes_1 = rawOptionTypes; _i < rawOptionTypes_1.length; _i++) {
                var optType = rawOptionTypes_1[_i];
                updatedFormConfig.option_type.elementConfig.options.push(new DropdownOption({
                    label: _.get(optType, 'attributes.bg_name', ''),
                    value: _.get(optType, 'id'),
                }));
            }
        };
        // Method to set up product labels in form config
        _this.setupProductLabels = function (updatedFormConfig, rawOptionTypes) {
            for (var _i = 0, _a = Object.keys(_.get(rawOptionTypes, 'labels', null)); _i < _a.length; _i++) {
                var key = _a[_i];
                updatedFormConfig.product_label.elementConfig.options.push(new DropdownOption({
                    label: key,
                    value: key,
                }));
            }
        };
        // Method to delete status field from form config
        _this.deleteStatusField = function () {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            delete updatedFormConfig.status;
            _this.setState({ formConfig: updatedFormConfig });
        };
        // Method to fetch product details by ID
        _this.getProduct = function (id) {
            _this.api
                .getProduct(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на продукта';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        // Method to set data fetched to form config
        _this.setDataToForm = function (data) {
            // Create product from data attributes using your factory method
            var product = productFactory.createProduct(_.get(data, 'attributes', {}));
            // Clone the existing formConfig from state
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            // Set data to product form using productService method
            _this.productService.setDataToProductForm(updatedFormConfig, product);
            // Function to add value from corresponding element
            var addValueFromCorrespondingElement = function (obj) {
                for (var key in obj) {
                    if (obj[key].elementType === "buttonModal") {
                        var correspondingKey = key.replace("Copy", "");
                        if (obj[correspondingKey]) {
                            obj[key].value = obj[correspondingKey].value;
                            obj[key].valueJson = {
                                body: {
                                    id: "" + correspondingKey,
                                    rows: [
                                        {
                                            id: "" + correspondingKey,
                                            cells: [
                                                {
                                                    contents: []
                                                }
                                            ],
                                            columns: [
                                                {
                                                    id: "LW0qh6mDEB",
                                                    contents: [
                                                        {
                                                            id: "9I7WSiTa5e",
                                                            type: "html",
                                                            values: {
                                                                html: "" + obj[correspondingKey].value,
                                                                displayCondition: null,
                                                                containerPadding: "10px",
                                                                anchor: "",
                                                                _meta: {
                                                                    htmlID: "u_content_html_1",
                                                                    htmlClassNames: "u_content_html"
                                                                },
                                                                selectable: true,
                                                                draggable: true,
                                                                duplicatable: true,
                                                                deletable: true,
                                                                hideable: true
                                                            }
                                                        }
                                                    ],
                                                }
                                            ],
                                        }
                                    ],
                                },
                            };
                        }
                    }
                }
            };
            // Call the function with updatedFormConfig
            addValueFromCorrespondingElement(updatedFormConfig);
            // Set state with updated formConfig and validate form
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // Method to handle input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elType === 'autocomplete') {
                if (event.value) {
                    updatedFormElement.value = event.value;
                }
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // Method to submit form data
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var formattedArray = _.get(formData, 'brand_category_ids.value', []);
            var res = [];
            formattedArray.forEach(function (element) {
                res.push(Number(element.value));
            });
            var submittedProduct = productFactory.createProduct({
                bg_name: _.get(formData, 'bg_name.value', ''),
                en_name: _.get(formData, 'en_name.value', ''),
                bg_description: _.get(formData, 'bg_description.value', ''),
                en_description: _.get(formData, 'en_description.value', ''),
                price: _.get(formData, 'price.value', ''),
                slug: _.get(formData, 'slug.value', ''),
                position: Number(_.get(formData, 'position.value', 1)),
                line_name: _.get(formData, 'line_name.value', null),
                bg_subhead: _.get(formData, 'bg_subhead.value', null),
                en_subhead: _.get(formData, 'en_subhead.value', null),
                bg_usage: _.get(formData, 'bg_usage.value', null),
                en_usage: _.get(formData, 'en_usage.value', null),
                bg_pao: _.get(formData, 'bg_pao.value', null),
                en_pao: _.get(formData, 'en_pao.value', null),
                // composition: _.get(formData, 'composition.value', null),
                bg_manufacturer_information: _.get(formData, 'bg_manufacturer_information.value', null),
                en_manufacturer_information: _.get(formData, 'en_manufacturer_information.value', null),
                bg_features: _.get(formData, 'bg_features.value', null),
                en_features: _.get(formData, 'en_features.value', null),
                youtube_url: _.get(formData, 'youtube_url.value', null),
                promotion_percent_difference: _.get(formData, 'promotion_percent_difference.value', null),
                option_type: _.get(formData, 'option_type.value', null),
                brand: _.get(formData, 'brand.value.value', null),
                categories: _.get(formData, 'categories.value', []),
                label: _.get(formData, 'product_label.value', null),
                brand_categories: _.get(formData, 'brand_categories.value', []),
                bg_seo_description: _.get(formData, 'bg_seo_description.value', ''),
                en_seo_description: _.get(formData, 'en_seo_description.value', ''),
                meta_title: _.get(formData, 'meta_title.value', ''),
                meta_description: _.get(formData, 'meta_description.value', ''),
            });
            if (_this.editId !== '-1') {
                submittedProduct.Status = _.get(formData, 'status.value', null);
            }
            var actionMethod = _this.editId === '-1' ? _this.api.createProduct : _this.api.updateProduct;
            actionMethod({ product: submittedProduct }, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.bottomMessages.show({ severity: 'success', detail: 'Продуктът бе запазен успешно', life: 5000 });
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на продукт';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        // Method to navigate to products page
        _this.toProductsPage = function () {
            _this.props.history.push(AppRoutes.products.path);
        };
        // Method to suggest options based on user input
        _this.suggestOptions = function (event, type) {
            var searchString = event.query.toLowerCase();
            var searchMethod = type === 'brand' ? _this.api.searchBrands : _this.api.searchCategories;
            if (type === 'brand_categories') {
                searchMethod = _this.api.searchBrandCategory;
            }
            searchMethod(searchString)
                .then(function (response) {
                var data = _.get(response, 'data.data', []);
                var results = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var item = data_1[_i];
                    results.push({
                        label: type === 'brand'
                            ? _.get(item, 'attributes.name', '')
                            : _.get(item, 'attributes.bg_name', '') + " (" + _.get(item, 'attributes.slug', '') + ")",
                        value: _.get(item, 'id'),
                    });
                }
                var obj = {};
                obj[type === 'brand' ? 'brandsSuggestions' : 'categoriesSuggestions'] = results;
                _this.setState(obj);
            })
                .catch(function (error) {
                var defaultMessage = 'Не можахме да намерим опции';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        // Method to open the modal
        _this.openModal = function (formElementId) {
            var formElement = _this.state.formConfig[formElementId];
            _this.setState({
                showModal: true,
                currentId: formElementId,
                currentModalContent: {
                    designHtml: formElement.value || null,
                    designJson: formElement.valueJson || null,
                },
            });
        };
        // Method to close the modal
        _this.closeModal = function () {
            _this.setState({
                showModal: false,
                currentModalContent: {
                    designHtml: '',
                    designJson: null,
                },
            });
        };
        _this.showInfoModal = function () {
            _this.setState({
                showModal: false,
            });
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[_this.state.currentId]);
            updatedFormElement.value = _this.state.currentModalContent.designHtml;
            updatedFormElement.valueJson = _this.state.currentModalContent.designJson;
            updatedFormConfig[_this.state.currentId] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // Method to handle design export from Email component
        _this.handleDesignExport = function (html, json) {
            _this.setState(function (prevState) { return ({
                currentModalContent: {
                    designHtml: html || '',
                    designJson: json
                },
            }); });
        };
        return _this;
    }
    ProductForm.prototype.componentDidMount = function () {
        var _this = this;
        // Fetch data on component mount
        this.editId = _.get(this.props, 'match.params.id', '-1');
        this.productService
            .fetchAsyncFieldsOptions()
            .then(function (data) {
            _this.setupFieldsOptions(data);
        })
            .catch(function (error) {
            var defaultMessage = 'Опциите за някое или за всички полета не можаха да бъдат заредени. Опитайте отново!';
            _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
        });
    };
    ProductForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, showModal = _a.showModal, currentModalContent = _a.currentModalContent, formConfig = _a.formConfig, formIsValid = _a.formIsValid, brandsSuggestions = _a.brandsSuggestions, categoriesSuggestions = _a.categoriesSuggestions;
        var formElementsArray = [];
        var modalInfo;
        // Turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        if (formConfig.hasOwnProperty(this.state.currentId)) {
            modalInfo = {
                config: formConfig[this.state.currentId],
                id: this.state.currentId
            };
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) { return (React.createElement(React.Fragment, null,
            React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, multiple: formElement.id === 'brand' ? false : true, changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                }, suggestions: formElement.id === 'brand' ? brandsSuggestions : categoriesSuggestions, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); }, modalButtonAction: function (event) { return _this.openModal(formElement.id); }, buttonModalText: "Промяна на съдържанието", modalhtmlContent: formElement.config.value && Object.keys(formElement.config.value).length > 0 ? formElement.config.value : null, modalButton: formElement.config.elementType === 'buttonModal' ? true : false }))); });
        // Modal content
        var modalContent = showModal && currentModalContent ? (React.createElement(Dialog, { visible: showModal, onHide: this.closeModal, header: "\u041F\u0440\u043E\u043C\u044F\u043D\u0430 \u043D\u0430 \u0441\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435\u0442\u043E" },
            React.createElement("div", null,
                React.createElement(Email, { onDesignExport: this.handleDesignExport, designHtml: modalInfo.config.value, designJson: modalInfo.config.valueJson })),
            React.createElement("div", { className: "p-d-flex p-jc-end" },
                React.createElement(Button, { label: "Close", onClick: this.closeModal }),
                React.createElement(Button, { label: "Save", onClick: this.showInfoModal })))) : null;
        // Action buttons
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toProductsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            modalContent,
            React.createElement(Messages, { ref: function (el) {
                    _this.bottomMessages = el;
                } }),
            actionBtns));
    };
    return ProductForm;
}(React.Component));
// @ts-ignore
export default withRouter(ProductForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Products/ProductForm/ProductForm.tsx
// module id = 405
// module chunks = 0